import { Box } from "@prismicio/editor-ui"
import type { PropsWithChildren } from "react"

import { useContentOffset } from "../../app/layout/useOffset"
import {
  headerBottomMargin,
  sidePanelWidth,
} from "../../document/documentLayout"
import { sidePanelPadding } from "../documentListLayout"
import { DocumentListLocales } from "./DocumentListLocales"
import { DocumentListMenu, type SelectedMenuItem } from "./DocumentListMenu"

interface DocumentListSidePanelProps {
  selectedMenuItem?: SelectedMenuItem
}

export function DocumentListSidePanel(props: DocumentListSidePanelProps) {
  const { selectedMenuItem } = props
  return (
    <LeftSidePanelLayout>
      <DocumentListLocales />
      <DocumentListMenu selectedMenuItem={selectedMenuItem} />
    </LeftSidePanelLayout>
  )
}

export function LeftSidePanelLayout(props: PropsWithChildren) {
  const { children } = props
  const { contentOffset } = useContentOffset()

  return (
    <Box
      flexGrow={1}
      overflowY="auto"
      position="fixed"
      flexDirection="column"
      height={`calc(100vh - ${contentOffset}px)`}
      width={sidePanelWidth}
      padding={{ top: headerBottomMargin, ...sidePanelPadding }}
      border={{ right: true }}
      borderStyle="dashed"
      gap={24}
    >
      {children}
    </Box>
  )
}
